<script>
export default {
  name: 'SelectWithInputOption',

  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
    // This value triggers the text box to open
    triggerValue: {
      required: false,
      default: 'other',
    },
    options: {
      required: false,
      default: ', other'
    },
    inputName: {
      required: true,
      default: 'input'
    }
  },

  data() {
    return {
      selected: '',
      selectOptions: [],
      showTextBox: false,
      textValue: '',
    };
  },

  created() {
    this.selectOptions = this.options.split(', ');
    if (!this.selectOptions.includes(this.value) && this.value !== "") {
      this.selected = "other"
      this.showTextBox = true;
      this.textValue = this.value;
    } else {
      this.selected = this.value;
    }
  },

  methods: {
    checkTextInput(value) {
      this.showTextBox = value === this.triggerValue;
    }
  },
};

</script>

<template>
  <div class="mb-4">
    <select :name="this.showTextBox ? '' : this.inputName" @change="checkTextInput(this.selected)" v-model="this.selected"
            class="bg-secondary rounded border border-grey-lighter w-full py-2 px-3 leading-tight focus:outline-none">
      <option value="">Select One...</option>
      <template v-for="option in this.selectOptions">
        <option :value="option">{{ option }}</option>
      </template>
      <option value="other">Other (fill in)</option>
    </select>
  </div>
  <div class="mb-4" v-show="this.showTextBox">
    <input placeholder="Enter here..." v-model="this.textValue" :name="this.showTextBox ? this.inputName : ''" class="bg-secondary rounded border border-grey-light w-full py-2 px-3 leading-tight focus:outline-none">
  </div>
</template>
